import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const CursosDefault = Default;

export default CursosDefault;
export const CursosAdicionar = Adicionar;
export const CursosEditar = Editar;
